import { q, qq } from "../../helper/q"

export const switchPriceInit = () => {
  const switchPriceButtons = qq(".priceVersionsContentButton")
  const switchPriceText = q(".priceVersionsText")
  if (switchPriceButtons) {
    switchPriceButtons.map(switchPriceButton => {
      switchPriceButton.addEventListener("click", () => {
        removeActive(switchPriceButtons)
        switchPriceButton.disabled = true
        switchPriceText.innerHTML = switchPriceButton.dataset.messageShort
        switchPrice(switchPriceButton.dataset.switchType)
      })
    })
  }
}

const removeActive = buttons => {
  buttons.map(button => {
    button.disabled = false
  })
}

const switchPrice = type => {
  const prices = qq(".priceText")
  switch (type) {
    case "kg":
      prices.forEach(price => {
        price.innerHTML = price.dataset.pricePerKg
      })
      sendToBitrix(type)
      break
    case "pack":
      prices.forEach(price => {
        price.innerHTML = price.dataset.pricePerPack
      })
      sendToBitrix(type)
      break

    default:
      prices.forEach(price => {
        price.innerHTML = price.dataset.pricePerKg
      })
      sendToBitrix(type)
      break
  }
}

const sendToBitrix = type => {
  return fetch("/ajax/setUnit.php", {
    method: "POST",
    credentials: "include",

    body: JSON.stringify({
      unit: type
    })
  }).then(page => page.text())
}
